// frontend/klaes-app/src/utils/api.js

// EINE einzige Base-URL für die gesamte App
export const API_BASE =
  process.env.REACT_APP_API_URL || 'http://klaes.info' || 'http://klaes.at';

/**
 * Zentraler Helper für authentifizierte Requests.
 * Wirft bei HTTP-Fehlern einen Error mit .status und .data.
 * Bei leerem Body und ok-Status wird `null` zurückgegeben.
 */
export async function apiFetch(path, { token, method = "GET", body } = {}) {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  let data = null;

  if (text && text.trim() !== "") {
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error(
        `[apiFetch] JSON Parse Error (HTTP ${res.status}) für ${path}:`,
        text.substring(0, 200),
      );
      const err = new Error(`Ungültige JSON-Antwort (HTTP ${res.status})`);
      err.status = res.status;
      err.rawText = text;
      throw err;
    }
  } else if (!res.ok) {
    const err = new Error(`Leere Antwort (HTTP ${res.status}) von ${path}`);
    err.status = res.status;
    throw err;
  }

  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) || `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  // Leerer Body bei ok-Status → leere Liste zurückgeben
  if (data === null && res.ok) {
    return [];
  }

  return data;
}

/* ============================================
   AUTH
============================================ */

export async function apiPostAuth(path, body) {
  return apiFetch(path, { method: 'POST', body });
}

export async function apiLogout(token) {
  return apiFetch('/api/auth/logout', { token, method: 'POST' });
}

/* ============================================
   USER
============================================ */

export async function apiGetUsers(token) {
  return apiFetch('/api/users', { token });
}

export async function apiGetUserProfile(token) {
  return apiFetch('/api/user/profile', { token });
}

export async function apiPutUserProfile(token, profileData) {
  return apiFetch('/api/user/profile', {
    token,
    method: 'PUT',
    body: profileData,
  });
}

export async function apiGetUserUiProps(token) {
  return apiFetch('/api/user/ui-props', { token });
}

export async function apiPutUserUiProps(token, uiProps) {
  return apiFetch('/api/user/ui-props', {
    token,
    method: 'PUT',
    body: { ui_props: uiProps },
  });
}

/* ============================================
   ONLINE USERS
============================================ */

export async function apiGetOnlineUsers(token) {
  return apiFetch('/api/online-users', { token });
}